import { useState, useEffect, useContext } from "react";
import { MobXProviderContext } from "mobx-react";
import type { Store } from "@inferno/renderer-shared-core";

const useGeoCountry = () => {
  const [geoCountry, setGeoCountry] = useState<string>("");
  const { store } = useContext(MobXProviderContext) as { store?: Store };

  useEffect(() => {
    const countryCode = (store?.request?.countryCode || "").toUpperCase();
    const resolved = ["US", "CA"].includes(countryCode) ? countryCode : countryCode ? "US" : "";
    setGeoCountry(resolved);
  }, [store?.request?.countryCode]);

  return geoCountry;
};

export default useGeoCountry;
